import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ImgTypePipe } from 'src/app/shared/pipes';
import { ImageLoaderComponent } from '../image-loader/image-loader.component';

@Component({
    standalone: true,
    selector: 'app-lib-logo-payment-method',
    templateUrl: './logo-payment-method.component.html',
    styleUrls: ['./logo-payment-method.component.scss'],
    imports: [ImgTypePipe, ImageLoaderComponent, CommonModule],
})
export class LogoPaymentMethodComponent {
    @Input() paymentMethodName: string;
    @Input() alt: string;
    @Input() title: string;
    @Input() width = '80px';
    @Input() height = 'auto';
}
